import { UploadFile } from 'antd';
import { TaskFileDetail } from './taskQueue';

export type FileData = UploadFile | TaskFileDetail;

// 文件全新啊
export enum FileACL {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Group = 'GROUP',
}
